import React, { useMemo } from 'react'
import { Map, List } from 'immutable'
import _compact from 'lodash/compact'
import { createTitleGroupId } from 'services/content'
import { H3 } from 'components/Heading'
import Button, { TYPES as BUTTON_TYPES } from 'components/Button'
import SharePageV3Tiles from './SharePage.v3Tiles'

/**
 * The share related media component
 * @param {Map} props.section - The pm section data
 * @param {Map} props.staticText - The static text
 * @param {Object} props.offerLink - The offer link url and query data
 * @param {String} props.rainbowCategory - The rainbow category ID
 * @param {Function} props.onOfferClick - The offer button click handler
 * @returns {JSX.Element} related media component
 */
function SharePageV3RelatedMedia (props) {
  const {
    section = Map(),
    language,
    staticText,
    offerLink = {},
    rainbowCategory,
    onOfferClick,
  } = props

  const headerLabel = section.getIn(['data', 'data', 'header', 'label'], '')
  const footerLabel = section.getIn(['data', 'data', 'footer', 'label'], '')
  const tabs = section.getIn(['data', 'data', 'tabs'], List())

  const titleGroupIds = useMemo(() => {
    let tabData = tabs.find((tab) => {
      const parsedLabel = tab.get('tabLabel', '').split('-')
      return parsedLabel.includes(rainbowCategory)
    })
    if (!tabData) {
      tabData = tabs.get(0) || Map()
    }
    const tabContent = tabData.get('tabContent') || List()
    return _compact(tabContent.map((item) => {
      return createTitleGroupId(item.get('contentId'), item.get('contentType'))
    }).toJS())
  }, [tabs, rainbowCategory])

  if (!titleGroupIds || titleGroupIds.length === 0) {
    return null
  }

  return (
    <div className="share-page-v3__related-media">
      <p className="share-page-v3__related-media-subtitle">{headerLabel}</p>
      <H3 className="share-page-v3__related-media-title">{footerLabel}</H3>
      <SharePageV3Tiles titleGroupIds={titleGroupIds} language={language}/>
      <Button
          className="share-page-v3__related-media-offer-button"
          type={BUTTON_TYPES.PRIMARY}
          onClick={onOfferClick}
          {...offerLink}
        >
          {staticText.get('claimMySpecialOffer')}
        </Button>
    </div>
  )
}

export default SharePageV3RelatedMedia
